/**
 * Created by 58 on 2016/12/28.
 */

var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('../../template/msg/card-msg-item.html');
/*require('./../../style/msg/card-msg-item.less');*/
var XssFilter = require('../../../lib/XssFilter');

var CardMsgItem = function (options) {
    (function (self) {
        var defaults = {
            template: template
        };
        $.extend(defaults, options);
        BaseMsgItem.call(self, defaults);
    })(this);

    // 是否已经被render过
    this._rendered = false;
};
CardMsgItem.prototype = Object.create(BaseMsgItem.prototype);

CardMsgItem.prototype.renderContent = function () {
    var msg = this._data.msg;
    var content = msg.content;
    var element = this._element;
    var img = element.find(".im-card-thumbnail");
    var title = element.find(".im-card-title");
    var describe = element.find(".im-card-word");
    var price = element.find(".im-card-price");
    if (!msg) {
        return false;
    }
    if (!content.url) {
        content.url = 'javascript:void(0);'
    }
    img.attr("href", content.url).css({
        "background-image": "url(" + content.thumbnail + ")"
    });
    // xssFilter,将'<'替换成’&lt;将'>'替换成&gt;
  title.attr("href", content.url).html(XssFilter.doFilter(content.title));
  describe.html(XssFilter.doFilter(content.describe));
  price.html(XssFilter.doFilter(content.price));
};


module.exports = CardMsgItem;

